import moment from 'moment'

// 法定休憩時間(労働基準法第34条)のバリデーション。
// data-duration-start-key/data-duration-end-key(実働時間の算出元)とdata-sum-field-key
// (もう一方の休憩フィールド)で指定された値から、休憩時間の合計が実労働時間に対して
// 法定の下限を満たしているか判定する。
// 6時間以下: 0分、6時間超8時間以下: 45分、8時間超: 60分

// toggle-form.jsのtoggle-trigger-keyと同様、同じフォーム内の別フィールドを
// (nameのkey部分を置換して)キー名で参照する。form-validator.jsのfindFieldByKeyと同じ実装。
const findFieldByKey = (el, key) => {
  const form = $(el).closest('form')
  const name = $(el).attr('name')
  const targetName = name.replace(/\[(?!.*\[).*/, '[' + key + ']')
  return form.find('input[name="' + targetName + '"],select[name="' + targetName + '"]')
}

// data-duration-start-key / data-duration-end-key で指定した2つの日時フィールド(datetime-local)から
// 実働時間(分)を算出する。どちらか未入力の場合はnull(判定不可のため呼び出し元でスキップ)
const getDurationMinutes = (el) => {
  const startVal = findFieldByKey(el, $(el).data('duration-start-key')).val()
  const endVal = findFieldByKey(el, $(el).data('duration-end-key')).val()
  if (!startVal || !endVal) {
    return null
  }
  const start = moment(startVal, "YYYY-MM-DDTHH:mm")
  let end = moment(endVal, "YYYY-MM-DDTHH:mm")
  // 終了時間が開始時間より前の場合は翌日終了(日跨ぎ)として扱う
  if (end.isBefore(start)) {
    end = end.clone().add(1, 'day')
  }
  return end.diff(start, 'minutes')
}

// 実労働時間(分)に対する法定休憩時間(分)を返す(労働基準法第34条)
// 6時間以下: 0分、6時間超8時間以下: 45分、8時間超: 60分
const getRequiredLegalBreakMinutesByWorkMinutes = (workMinutes) => {
  if (workMinutes <= 360) {
    return 0
  } else if (workMinutes <= 480) {
    return 45
  } else {
    return 60
  }
}

// 対象フィールドの値・data-sum-field-keyで指定された相方フィールドの値から、
// 休憩合計(totalBreak)と実労働時間(workMinutes)を算出する。
// 開始・終了時刻が未入力で判定不可の場合はnullを返す。
const getBreakContext = (value, el) => {
  const duration = getDurationMinutes(el)
  if (duration === null) {
    return null
  }
  const otherValue = Number(findFieldByKey(el, $(el).data('sum-field-key')).val()) || 0
  const totalBreak = Number(value) + otherValue
  const workMinutes = duration - totalBreak
  return { totalBreak, workMinutes }
}

// form-validator.jsの'legal_break_time'ルールから呼び出されるバリデーション本体
export const validLegalBreakTime = (value, el) => {
  const context = getBreakContext(value, el)
  if (context === null) {
    return true
  }
  const required = getRequiredLegalBreakMinutesByWorkMinutes(context.workMinutes)
  return context.totalBreak >= required
}

// form-validator.jsのエラーメッセージ生成から呼び出される、現在の入力に対する必要な法定休憩時間(分)
export const getRequiredLegalBreakMinutes = (value, el) => {
  const context = getBreakContext(value, el)
  if (context === null) {
    return 0
  }
  return getRequiredLegalBreakMinutesByWorkMinutes(context.workMinutes)
}

// 開始時間・終了時間・もう一方の休憩フィールドが変更された時、実働時間バリデーション
// (less_than_duration/sum_less_than_duration/legal_break_time/job_komi_break_time_band)対象フィールド自身の
// バリデーションを再実行する。form-validator.jsのonChangeFieldから呼び出される。
// (formValidedAtLeastOnceがfalseの間は変更されたフィールド自身しか再検証されないため、
//  依存元フィールドを変更してもエラーが残ったままになってしまうのを防ぐ)
export const retriggerDurationValidationOnChange = (form, changedField) => {
  form.find('[data-rules*="less_than_duration"],[data-rules*="legal_break_time"],[data-rules*="job_komi_break_time_band"]').each((i, el) => {
    const $el = $(el)
    if (!$el.val()) {
      return
    }
    const dependentKeys = [
      $el.data('duration-start-key'),
      $el.data('duration-end-key'),
      $el.data('sum-field-key')
    ].filter(Boolean)
    const isDependent = dependentKeys.some((key) => changedField.is(findFieldByKey(el, key)))
    if (isDependent) {
      $el.trigger('change')
    }
  })
}
